/**
 * 表格操作逻辑 Hook
 */
import { message } from 'antd';
import { getDriverArchiveList, updateDriverRegistrationInfo, syncDriverArchiveInfoNew, syncDriverArchiveInfoUpdate } from '@/service/driverArchive';

export const useTableOperations = (
  getData: () => void,
  openSimilarDriversModal: (drivers: any[], currentRecord: any) => void
) => {
  // 审核提交
  const handleReviewOk = async (values: any) => {
    try {
      console.log('审核提交:', values);
      const res = await updateDriverRegistrationInfo(values);
      if (res.data?.success) {
        message.success('审核成功');
        await getData(); // 刷新列表
        return true;
      } else {
        message.error(res.data?.msg || '审核提交失败');
        return false;
      }
    } catch (error) {
      console.error('审核提交失败:', error);
      message.error('审核提交失败');
      return false;
    }
  };

  // 关联人脸库提交
  const handleLinkFaceLibOk = () => {
    // TODO: 实现关联人脸库逻辑
    getData(); // 刷新列表
  };

  // 同步更新司机档案
  const handleSyncArchive = async (record: any) => {
    const name = record?.name?.trim() || '';
    if (!name) {
      message.warning('无法同步档案');
      return;
    }

    let driverList = [];
    try {
      const res = await getDriverArchiveList({
        name,
      });

      const resData = res.data?.data || [];
      driverList = resData;
    } catch (error) {
      console.error('同步更新司机档案失败:', error);
      message.error('同步更新司机档案失败');
      return; // 出错时终止执行
    }

    if (driverList.length === 0) {
      // 完全新增逻辑 - 没有近似司机，直接新建
      await handleSyncArchiveNew(record);
    } else {
      // 显示名称近似司机弹窗
      openSimilarDriversModal(driverList, record);
    }
  };

  // 完全新增司机档案（从弹窗调用或没有近似司机时调用）
  const handleSyncArchiveNew = async (currentRecord: any) => {
    try {
      const res = await syncDriverArchiveInfoNew(
        currentRecord,
      );
      if (res.data?.success) {
        message.success('新建司机档案成功');
        await getData(); // 刷新列表
        return true;
      } else {
        message.error(res.data?.msg || '新建司机档案失败');
        return false;
      }
    } catch (error) {
      console.error('新建司机档案失败:', error);
      message.error('新建司机档案失败');
      return false;
    }
  };

  // 更新司机档案（选择近似司机后调用）
  const handleSyncArchiveUpdate = async (currentRecord: any, selectedDriver: any) => {
    try {
      const driverId = selectedDriver.id;
      const res = await syncDriverArchiveInfoUpdate(
        currentRecord,
        driverId
      );
      if (res.data?.success) {
        message.success('更新司机档案成功');
        await getData(); // 刷新列表
        return true;
      } else {
        message.error(res.data?.msg || '更新司机档案失败');
        return false;
      }
    } catch (error) {
      console.error('更新司机档案失败:', error);
      message.error('更新司机档案失败');
      return false;
    }
  };

  return {
    handleReviewOk,
    handleLinkFaceLibOk,
    handleSyncArchive,
    handleSyncArchiveNew,
    handleSyncArchiveUpdate,
  };
};
